<script setup>
const { t, locale } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center justify-center">
    <img src="~/assets/images/common/404.png" class="" alt="404">
    <h1 class="mt-6 font-semibold text-textSecondary">
      {{ t('抱歉，您访问的页面不存在') }}
    </h1>
    <a :href="`/${locale}`" class="mt-4 text-sm text-primary">{{ t('返回首页') }} ></a>
  </div>
</template>
